import { render, staticRenderFns } from "./popupsReady.vue?vue&type=template&id=52658b80&"
import script from "./popupsReady.vue?vue&type=script&lang=js&"
export * from "./popupsReady.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52658b80')) {
      api.createRecord('52658b80', component.options)
    } else {
      api.reload('52658b80', component.options)
    }
    module.hot.accept("./popupsReady.vue?vue&type=template&id=52658b80&", function () {
      api.rerender('52658b80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/popupsReady.vue"
export default component.exports